<div class="document-lines-drawer">
  <div class="document-lines-toolbar">
    <nz-input-group [nzPrefix]="searchIcon">
      <input
        nz-input
        [(ngModel)]="searchText"
        (ngModelChange)="applySearch()"
        [placeholder]="'Search lines' | locale"
      />
    </nz-input-group>
    <ng-template #searchIcon>
      <i nz-icon nzType="search" nzTheme="outline"></i>
    </ng-template>
    <span class="line-count">
      {{ filteredRows.length }} / {{ rows.length }}
    </span>
  </div>

  <nz-table
    #documentLinesTable
    nzBordered
    nzSize="small"
    [nzData]="filteredRows"
    [nzFrontPagination]="false"
    [nzScroll]="{ x: tableWidth + 80 + 'px', y: 'calc(100vh - 210px)' }"
  >
    <thead>
      <tr>
        <th nzWidth="64px" nzLeft>#</th>
        <th
          *ngFor="let field of fields; trackBy: trackByFieldName"
          [nzWidth]="
            field.AdditionalInformationParsed?.Width === 0
              ? '140px'
              : field.AdditionalInformationParsed?.Width + 'px'
          "
        >
          {{ field.Label | locale }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let row of documentLinesTable.data;
          trackBy: trackByRowKey
        "
        [ngClass]="{
          'text-line-row': row.rowType === 'text',
          'subtotal-line-row': row.rowType === 'subtotal'
        }"
      >
        <td nzLeft>{{ row.rowNumber }}</td>
        <td *ngFor="let field of fields; trackBy: trackByFieldName">
          {{ row.values[field.PropertyName] }}
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
